export default [
  {
    path: "/contractor",
    name: "contractor",
    component: () => import("@/modules/contractor/Contractor.vue"),
    children: [
      {
        path: "list",
        name: "list-contractors",
        component: () => import("@/modules/contractor/pages/ContractorList.vue"),
        meta: { permissions: ["suppliers-show"] }
      },
      {
        path: "add",
        name: "add-contractor",
        component: () => import("@/modules/contractor/pages/ContractorAdd.vue"),
        meta: { permissions: ["suppliers-create"] }
      },
      {
        path: "edit/:id",
        name: "edit-contractor",
        component: () => import("@/modules/contractor/pages/ContractorEdit.vue"),
        meta: { permissions: ["suppliers-update"] }
      }
    ]
  }
];